export interface BasicOption {
	value: string;
	label: string;
}

/**
 * Response from /api/kayak-redirect endpoint
 */
export interface KayakRedirectResponse {
	url: string | null;
	success: boolean;
	error?: string;
}

/**
 * Allocation for hotel rooms
 */
export interface Allocation {
	adults: number;
	childAge: number[];
}

export const DEFAULT_ALLOCATION: Allocation = {
	adults: 2,
	childAge: [],
};

/**
 * Place type for Kayak search
 */
export enum SearchPlaceType {
	HOTEL = 'Hotels',
	CITY = 'Cities',
	REGION = 'Regions',
	COUNTRY = 'Countries',
	AIRPORT = 'Airports',
	LANDMARK = 'Landmark',
}

/**
 * Sort options for Kayak search
 */
export enum SORT_BY {
	POPULARITY = 'popularity',
	PRICE = 'price',
	RATING = 'rating',
}

/**
 * Request parameters for Kayak pick-in-place API
 */
export interface SearchInPlaceRequestParams {
	allocations?: Allocation[];
	checkIn?: string;
	checkOut?: string;
	currency?: string;
	language?: string;
	place?: {
		name: string;
		type: SearchPlaceType;
		entityKey?: string;
	};
	query?: string;
	timeZone?: string;
	utcOffsetMinutes?: number;
	page?: number;
	perPage?: number;
	sort?: {
		by: SORT_BY;
	};
	userAgent?: string;
	sessionID?: string;
	ap?: string; // Provider code from fuid mapping
	clientIP?: string; // Real client IP
}
